/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
import { Box, Typography, Grid } from "@mui/material";
import { Formik } from "formik";
import { compose, keyBy, pickBy } from "lodash/fp";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import * as Sentry from "@sentry/react";
import html2canvas from "html2canvas";
import JsPDF from "jspdf";
import CommitteeParticipate from "../../../components/AppointmentModals/FeedBack/CommiteeParticipateModal";
import Button from "../../../components/common/Button";
import Modal from "../../../components/common/Modal/Modal";
import { CommonStyles } from "../../../components/common/Button/commonButtonStyle";
import RejectAppointmentApplication from "../../../components/RejectAppointmentApplication/RejectAppointment";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";
import { AlertStatus } from "../../../contants";
import { appointmentQuestions } from "../../../contants/appointment";
// import { APPOINTMENT_ENTRY } from "../../../contants/formFields";
import {
  selectMemberForAppointmentApply,
  selectSelectedPositionId,
} from "../../../redux/selectors/appointment";
import {
  selectAllSIUsers,
  selectUserRole,
  selectUserProfile,
} from "../../../redux/selectors/user";
import Member from "../../../services/api/member";
// import { ROUTES } from "../../../utils/constants";
import {
  debounce,
  isEmptyObj,
  NextChiefNameMapper,
} from "../../../utils/helper";
import GeneralRemark from "./GeneralRemark/GeneralRemark";
import { formValidate, interviwerValidation } from "./helper";
import LeaderForm from "./LeaderForm/LeaderForm";

import OtherDetails from "./OtherDetails/OtherDetails";
import PersonalDetails from "./PersonalDetails/PersonalDetails";
import AddMemberModal from "../../../components/AppointmentModals/AddMemberModal/AddMemberModal";
import MemberRelationship from "./MemberRelationship/MemberRelationship";
import MemberInterviewedForm from "./MemberInterviewedForm/MemberInterviewedForm";
import Loader from "../../../components/common/Loader/Loader";
import ARCVotingModal from "../AppointmentTracking/components/ARCVotingModal";
import AACVotingModal from "../AppointmentTracking/components/AACVoting";
import { SET_RESET_APPOINTMENT_STATE } from "../../../redux/actionTypes/dashboard";
// import ForcePushAppointmentApplication from "../../../components/AppointmentModals/ForcePushAppointmentApplication/ForcePushAppointment";
import RecommendedByForm from "./RecommendedByForm/RecommendedByForm";
// import Alert from "../../../components/common/new/Alert/Alert";
import Appointment from "../../../services/api/appointment";

const getAllAnswers = (memberData) => {
  const {
    blockChiefAnswers,
    districtChiefAnswers,
    regionChiefAnswers,
    chapterChiefAnswers,
    zoneChiefAnswers,
  } = memberData;
  let answers = [];
  if (blockChiefAnswers?.length) answers = answers.concat(blockChiefAnswers);
  if (districtChiefAnswers?.length)
    answers = answers.concat(districtChiefAnswers);
  if (regionChiefAnswers?.length) answers = answers.concat(regionChiefAnswers);
  if (zoneChiefAnswers?.length) answers = answers.concat(zoneChiefAnswers);
  if (chapterChiefAnswers?.length)
    answers = answers.concat(chapterChiefAnswers);

  return answers;
};

const READ_MODE_ROUTES = [
  "verification",
  "recommended",
  "interview",
  "partial-reviewed",
  "partial-approved",
  "tracking",
  "recommended2",
  // "forcepush",
];

const getInitialFormData = (memberData, readOnly) => {
  if (!readOnly) return {};
  const allAnswers = getAllAnswers(memberData);
  const answersMap = keyBy("questionId", allAnswers);

  return appointmentQuestions.reduce((acc, curr) => {
    if (curr.questionId in answersMap) {
      if (curr.answerType === "boolean") {
        return {
          ...acc,
          [curr.key]: answersMap[curr.questionId]?.answer ? "YES" : "NO",
        };
      }
      return { ...acc, [curr.key]: answersMap[curr.questionId]?.answer ?? "" };
    }
    return acc;
  }, {});
};

function Alert({ open, onClose, onSubmit, isLoading }) {
  return (
    <Box>
      <Modal open={open} onClose={onClose}>
        <Typography
          style={{ fontSize: "20px", fontWeight: "500", paddingBottom: "20px" }}
        >
          Are you sure you want to
          <br />
          recommend this application ?
        </Typography>
        <Box style={{ paddingTop: "50px", justifyContent: "space-between" }}>
          <Button
            onClick={onSubmit}
            label="Yes"
            style={{ marginRight: "10px" }}
            disabled={isLoading}
          />
          <Button onClick={onClose} label="No" variant="outlined" />
        </Box>
      </Modal>
    </Box>
  );
}

function AlertAccept({ open, onClose, onSubmit, isLoading }) {
  return (
    <Box>
      <Modal open={open} onClose={onClose}>
        <Typography
          style={{ fontSize: "20px", fontWeight: "500", paddingBottom: "20px" }}
        >
          Are you sure you want to
          <br />
          mark the interaction ?
        </Typography>
        <Box style={{ paddingTop: "50px", justifyContent: "space-between" }}>
          <Button
            onClick={onSubmit}
            label="Yes"
            style={{ marginRight: "10px" }}
            disabled={isLoading}
          />
          <Button onClick={onClose} label="No" variant="outlined" />
        </Box>
      </Modal>
    </Box>
  );
}

function AppointmentSubmission() {
  const memberData = useSelector(selectMemberForAppointmentApply);
  const selectedPositionId = useSelector(selectSelectedPositionId);
  const { isDistrictSi, isChapterSi, isRegionSi, isZoneSi, isAreaSi } =
    useSelector(selectAllSIUsers);
  const userRole = useSelector(selectUserRole);
  const [memberRelationship, setMemberRelationship] = useState(null);
  const [committeeModalOpen, setCommitteeModalOpen] = useState(false);
  const [rejectAppointmentModal, setRejectAppointmentModal] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { type } = useParams();
  const readOnly = READ_MODE_ROUTES.includes(type);
  const memberInfo = memberData.memberDetails ?? memberData;
  const structureLevel = memberData?.structureLevel ?? "";
  const selectChiefLabel = structureLevel || NextChiefNameMapper[userRole];
  const [memberDetails, setMemberDetails] = useState(null);
  const toast = useContext(ToastAlertContext);
  const [openAddMembertModal, setOpenAddMembertModal] = useState(false);
  const [relationData, setRelationData] = useState({});
  const [options, setOptions] = useState([]);
  const [ids, setIds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [familyMember, setFamilyMember] = useState(null);
  const [openARCModal, setOpenARCModal] = useState(false);
  const [openAACModal, setOpenAACModal] = useState(false);
  // const [forcePushModal, setForcePushModal] = useState(false);
  const userProfile = useSelector(selectUserProfile);
  const [structureChiefIds, setStructureChiefIds] = useState([]);
  const [structureChiefOptions, setStructureChiefOptions] = useState([]);
  const [openAlert, setOpenAlert] = useState(false);
  const [openAlertAccept, setOpenAlertAccept] = useState(false);
  const [votingData, setVotingData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const pdfRef = useRef(null);

  const [isDownloading, setIsDownloading] = useState(false);

  const downloadPdf = () => {
    setIsDownloading(true);
    const input = pdfRef.current;

    html2canvas(input, {
      useCORS: true,
      allowTaint: true,
      logging: true,
      width: input.scrollWidth,
      height: input.scrollHeight,
    })
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new JsPDF("p", "mm", "a4", true);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const imgWidth = canvas.width;
        const imgHeight = canvas.height;
        const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
        const imgX = (pdfWidth - imgWidth * ratio) / 2;
        const imgY = pdfHeight > imgHeight ? (pdfHeight - imgHeight) / 2 : 0;
        pdf.addImage(
          imgData,
          "PNG",
          imgX,
          imgY,
          imgWidth * ratio,
          imgHeight * ratio
        );
        pdf.save(
          `AppointmentForm-${memberInfo?.memberId}-${
            memberData?.id
          }-${new Date().toLocaleDateString()}`
        );
      })
      .then(() => setIsDownloading(false));
  };

  const [isVotingLoading, setIsVotingLoading] = useState(false);

  const onCreateFamily = () => navigate("/members/family/create");

  const onAddFamilyMember = () =>
    navigate(`/family/edit/${memberDetails.familyId}`);

  const getVotingData = async (ARC) => {
    setIsVotingLoading(true);
    try {
      const data = await Appointment.appointmentVoting(
        {
          committeeType: ARC === "recommend" ? "ARC" : "AAC",
          // status: memberData?.status,
        },
        memberData.id
      );
      setVotingData(data);
      setIsVotingLoading(false);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
    }
  };

  const onOpenAACModal = () => {
    setOpenAACModal(true);
    getVotingData();
  };
  const toggleAACModal = () => {
    setOpenAACModal((prev) => !prev);
  };

  const onOpenARCModal = () => {
    setOpenARCModal(true);
    getVotingData("recommend");
  };
  const toggleARCModal = () => {
    setOpenARCModal((prev) => !prev);
  };

  const toggleCommitteModal = () => {
    setCommitteeModalOpen((prev) => !prev);
  };

  // const toggleForcePushModal = () => {
  //   setForcePushModal((prev) => !prev);
  // };

  const toggleRejectAppointmentModal = () => {
    setRejectAppointmentModal((prev) => !prev);
  };

  const toggleAlert = () => setOpenAlert((prev) => !prev);

  const toggleAlertAccept = () => setOpenAlertAccept((prev) => !prev);

  const onBack = () => {
    dispatch({
      type: SET_RESET_APPOINTMENT_STATE,
    });
    navigate(-2);
  };

  const onAddMember = () => {
    setOpenAddMembertModal(true);
  };

  const toggleMemberModal = () => {
    setOpenAddMembertModal((prev) => !prev);
  };

  const fetchMemberRelationship = async (id) => {
    try {
      const { data } = await Member.getMemberDetailsById(id);
      setMemberRelationship(data.nonMemberRelatives);
    } catch (err) {
      Sentry.captureException(err);
    }
  };

  const fetchFamilyMember = async (id) => {
    try {
      const { data } = await Member.getRelationshipsByMemberId(id);
      setFamilyMember(data.content);
    } catch (err) {
      Sentry.captureException(err);
    }
  };

  const fetchList = async () => {
    try {
      const result = await Appointment.getInteractionList({
        areaId: userProfile.areaId,
        zoneId: userProfile.zoneId,
        regionId: userProfile.regionId,
        chapterId: userProfile.chapterId,
        districtId: userProfile.districtId,
      });

      const fullNames = result.data.flat().map((member) => {
        return { key: member.fullName, value: member.memberId };
      });

      setOptions(fullNames);
    } catch (err) {
      Sentry.captureException(err);
    }
  };

  const fetchStructureChiefList = async () => {
    try {
      const result = await Appointment.getStructureChiefs({});

      const fullNames = result.data.flat().map((member) => {
        return { key: member.fullName, value: member.memberId };
      });

      setStructureChiefOptions(fullNames);
    } catch (err) {
      Sentry.captureException(err);
    }
  };

  const fetchMemberDetails = async (id) => {
    try {
      setLoading(true);
      const { data } = await Member.getMemberDetailsById(id);
      setMemberDetails(data);
      setLoading(false);
    } catch (err) {
      Sentry.captureException(err);
    }
  };

  const getAnswer = (question, answer) => {
    if (question.answerType === "integer") return Number(answer);
    if (question.answerType === "boolean") return answer === "YES";
    return answer;
  };

  const prepareQNABody = (formValues) => {
    const getAllBooleanField = () => {
      return appointmentQuestions.reduce((acc, curr) => {
        if (curr.key in formValues) {
          return [
            ...acc,
            {
              questionId: Number(curr.questionId),
              answer: getAnswer(curr, formValues[curr.key]),
            },
          ];
        }
        return acc;
      }, []);
    };

    const getDistrictSiInputsPayload = (result) => {
      const chiefAnswerKey = `${selectChiefLabel.toLowerCase()}ChiefAnswers`;
      return {
        [chiefAnswerKey]: result,
      };
    };

    return compose(
      getDistrictSiInputsPayload,
      getAllBooleanField,
      pickBy(Boolean)
    )(formValues);
  };
  const onFormSubmit = async (values) => {
    setIsLoading(true);
    try {
      const cheifAnswers = prepareQNABody(values);
      const body = {
        ...cheifAnswers,
        appliedFor: selectedPositionId,
        currentPositionId: memberDetails?.positions?.[0]?.id || "",
        currentDualPositionId: memberDetails?.positions?.[1]?.id || "",
        nonMemberRelatives: relationData.relations || [],
        recommendedBy: structureChiefIds,
      };

      const error = formValidate(values, structureChiefIds, {
        isDistrictSi,
        isChapterSi,
        isZoneSi,
        isAreaSi,
        isRegionSi,
        memberDetails,
      });
      if (error) throw new Error(error);

      await Appointment.submitAppointment(body, memberInfo.memberId);

      toast.show("Successfully Done", AlertStatus.SUCCESS);
      setTimeout(() => onBack(), 2000);
    } catch (err) {
      setIsLoading(false);
      toast.show(err.message, AlertStatus.ERROR);
      Sentry.captureException(err);
    } finally {
      setIsLoading(false);
    }
  };

  const acceptAppointmentHandler = async () => {
    setIsLoading(true);
    try {
      const body = {
        memberId: memberInfo.memberId,
        interviewedBy: ids,
      };
      const error = interviwerValidation(ids);
      if (error) {
        throw new Error(error);
      }
      await Appointment.acceptedAppointment(memberData.id, body);
      toast.show("Successfully Done", AlertStatus.SUCCESS);
      setTimeout(() => onBack(), 2000);
    } catch (err) {
      setIsLoading(false);
      toast.show(err.message, AlertStatus.ERROR);
      Sentry.captureException(err);
    } finally {
      setIsLoading(false);
    }
  };

  console.log("votingData", votingData);

  const submitHandler = () => {
    if (readOnly) {
      if (type === "interview") {
        return toggleAlertAccept;
      }

      return toggleCommitteModal;
    }
    return toggleAlert;
  };

  useEffect(() => {
    if (!isEmptyObj(memberInfo)) {
      fetchMemberRelationship(memberInfo.memberId);
    }
  }, [memberInfo]);

  useEffect(() => {
    fetchStructureChiefList();
  }, []);

  useEffect(() => {
    if (!isEmptyObj(memberInfo)) {
      fetchMemberDetails(memberInfo.memberId);
    }
  }, [memberInfo]);

  useEffect(() => {
    if (!isEmptyObj(memberData)) {
      fetchList(memberData.id);
    }
  }, [memberData]);

  useEffect(() => {
    if (!isEmptyObj(memberInfo)) {
      fetchFamilyMember(memberInfo.memberId);
    }
  }, [memberInfo]);

  return (
    <Box>
      {/* <Formik
        enableReinitialize
        initialValues={getInitialFormData(memberData, readOnly)}
        onSubmit={debounce(submitHandler())}
      > */}
      <Formik
        enableReinitialize
        initialValues={getInitialFormData(memberData, readOnly)}
        onSubmit={debounce(submitHandler())}
      >
        {({ handleChange, values, handleSubmit, setFieldValue }) => {
          return (
            <form onSubmit={handleSubmit}>
              <Box
                ref={pdfRef}
                style={{
                  borderRadius: "14px",
                  border: "1px solid #E2E2E2",
                  background: "#F9F9F9",
                  boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                  padding: "15px",
                }}
              >
                <PersonalDetails
                  heading={
                    selectedPositionId
                      ? `Recommendation Form for appointment of ${selectChiefLabel} Chief ${
                          [50, 39, 30, 28, 59, 62, 63].includes(
                            selectedPositionId
                          )
                            ? "Deputy"
                            : ""
                        }`
                      : // : `Recommendation Form for appointment of ${memberData?.appliedForName}`
                      type === "recommended"
                      ? `Review for approval (L1) Form for appointment of ${memberData?.appliedForName}`
                      : type === "recommended2"
                      ? `Review for approval (L2) Form for appointment of ${memberData?.appliedForName}`
                      : `Recommendation Form for appointment of ${memberData?.appliedForName}`
                  }
                  memberInfo={memberInfo}
                  appliedDate={memberData?.createdAt}
                  memberDetails={memberDetails}
                  onOpenARCModal={onOpenARCModal}
                  onOpenAACModal={onOpenAACModal}
                  isDownloading={isDownloading}
                  downloadPdf={downloadPdf}
                />
                {/* <FamilyDetails /> */}

                <MemberRelationship
                  memberRelationship={memberRelationship}
                  showAddLink={!readOnly}
                  onAddMember={onAddMember}
                  familyMember={familyMember}
                  relationData={relationData.relations}
                  onCreateFamily={onCreateFamily}
                  onAddFamilyMember={onAddFamilyMember}
                  memberInfo={memberInfo}
                />
                <OtherDetails
                  values={values}
                  handleChange={handleChange}
                  // memberInfo={memberInfo}
                  memberDetails={memberDetails}
                  readOnly={readOnly}
                  setFieldValue={setFieldValue}
                  structureLevel={structureLevel}
                />
                <LeaderForm
                  readOnly={readOnly}
                  values={values}
                  handleChange={handleChange}
                  setFieldValue={setFieldValue}
                  structureLevel={structureLevel}
                />
                {type === "interview" && (
                  <MemberInterviewedForm
                    ids={ids}
                    setIds={setIds}
                    options={options}
                  />
                )}
                {/* 50-50 Grid Layout for General Remark and Recommended By */}
                <Grid container spacing={2} sx={{ px: { xs: 2, md: 0 } }}>
                  <Grid item xs={12} lg={6}>
                    <GeneralRemark
                      readOnly={readOnly}
                      values={values}
                      handleChange={handleChange}
                    />
                  </Grid>

                  <Grid item xs={12} lg={6}>
                    <RecommendedByForm
                      readOnly={readOnly}
                      structureChiefIds={structureChiefIds}
                      setStructureChiefIds={setStructureChiefIds}
                      structureChiefOptions={structureChiefOptions}
                      values={values}
                      recommendedBy={memberData.recommendedByName}
                    />
                  </Grid>
                </Grid>
                {/* )} */}
                {loading && <Loader />}
                {type !== "tracking" ? (
                  <div
                    style={{
                      display: "flex",
                      gap: 5,
                      justifyContent: "end",
                      margin: "20px 20px 20px 0px",
                    }}
                  >
                    <Button
                      variant="outlined"
                      style={{
                        ...CommonStyles.buttonStyle,
                        marginLeft: "20px",
                      }}
                      onClick={
                        type === "interview"
                          ? toggleRejectAppointmentModal
                          : onBack
                      }
                      label={type === "interview" ? "Reject" : "Cancel"}
                    />
                    {/* {( */}
                    <Button
                      variant="contained"
                      style={CommonStyles.buttonStyle}
                      type="submit"
                      label={
                        // readOnly
                        //   ? type === "interview"
                        //     ? "Accept"
                        //     : "Review"
                        //   : "Submit"
                        readOnly
                          ? type === "interview"
                            ? "Accept"
                            : type === "verification"
                            ? "Recommend"
                            : type === "recommended"
                            ? "Approve"
                            : type === "recommended2"
                            ? "Approve"
                            : type === "partial-reviewed"
                            ? "Recommend"
                            : // : type === "forcepush"
                            // ? "Force Push"
                            type === "partial-approved"
                            ? "Approve"
                            : "Review"
                          : "Submit"
                      }
                    />
                    {/* ) : null} */}
                  </div>
                ) : null}
                <Alert
                  open={openAlert}
                  onClose={toggleAlert}
                  onSubmit={() => onFormSubmit(values)}
                  isLoading={isLoading}
                />
                <AlertAccept
                  open={openAlertAccept}
                  onClose={toggleAlertAccept}
                  onSubmit={acceptAppointmentHandler}
                  isLoading={isLoading}
                />
              </Box>
            </form>
          );
        }}
      </Formik>
      <CommitteeParticipate
        open={committeeModalOpen}
        onClose={toggleCommitteModal}
        application={memberData}
        toast={toast}
        onBack={onBack}
      />
      <RejectAppointmentApplication
        open={rejectAppointmentModal}
        onClose={toggleRejectAppointmentModal}
        application={memberData}
        toast={toast}
        onBack={onBack}
      />
      <AddMemberModal
        setRelationData={setRelationData}
        open={openAddMembertModal}
        onClose={toggleMemberModal}
        toast={toast}
        memberRelationship={memberRelationship}
      />
      <ARCVotingModal
        open={openARCModal}
        onClose={toggleARCModal}
        memberData={memberData}
        votingData={votingData}
        isVotingLoading={isVotingLoading}
      />
      <AACVotingModal
        open={openAACModal}
        onClose={toggleAACModal}
        memberData={memberData}
        votingData={votingData}
        isVotingLoading={isVotingLoading}
      />
      {/* <ForcePushAppointmentApplication
        open={forcePushModal}
        onClose={toggleForcePushModal}
        application={memberData}
        toast={toast}
        onBack={onBack}
      /> */}
    </Box>
  );
}

export default AppointmentSubmission;
